export default __webpack_public_path__ + "static/media/hot-drinks.ce43cf8f.webp";